<template>
  <div class="w-full pb-4">
    <h4 class="mb-2 border-b pb-2 font-bold">Çalışma Günleri</h4>
    <div class="w-full items-center justify-center max-h-60">
      <div class="w-full flex mt-3">
        <div class="w-5/12 ml-2">
          <DaysOfWeekSelect v-model="days" :selectedList="List" />
        </div>
        <div class="w-3/12 ml-2">
          <diffInput
            type="time"
            title="Başlangıç"
            v-model="startHour"
            :hideContainer="true"
          />
        </div>
        <div class="w-3/12 ml-2">
          <diffInput
            type="time"
            title="Bitiş"
            v-model="endHour"
            :hideContainer="true"
          />
        </div>

        <div
          class="w-1/12 ml-2 rounded-md border flex items-center justify-end"
        >
          <button
            type="button"
            @click="save()"
            class="text-green-500 mx-auto py-1 px-2 rounded border border-green-500 text-sm"
          >
            <i class="fas fa-check"></i>
          </button>
        </div>
      </div>
      <div class="w-full flex"></div>
    </div>
    <div class="w-full pt-2 mt-2" v-if="List.length > 0">
      <LyrausTable
        :columns="columns"
        :data="sortedList"
        :tableHeight="'30vh'"
        :buttonsColumn="{ label: 'İşlem' }"
      >
        <template v-slot:colButtons="{ item, index }">
          <div class="flex items-center justify-end space-x-2 px-2">
            <button
              v-if="item.status === 3"
              type="button"
              @click="reverseDelete(index)"
              class="text-gray-500 text-sm"
            >
              <i class="fas fa-redo"></i>
            </button>
            <button
              v-else
              type="button"
              @click="removeItem(index, item)"
              class="text-red-500 text-sm"
            >
              <i class="fas fa-trash"></i>
            </button>
          </div>
        </template>
        <template v-slot:rowButtons="{ item, columnKey }">
          <div v-if="columnKey === 'startHour'">
            <diffInput
              type="time"
              v-model="item.startHour"
              :hideContainer="true"
            />
          </div>
          <div v-if="columnKey === 'endHour'">
            <diffInput
              type="time"
              v-model="item.endHour"
              :hideContainer="true"
            />
          </div>
        </template>
      </LyrausTable>
    </div>
  </div>
</template>
<script>
//npm
import { LyrausTable } from "lyraus-ui";

//global Components
import diffInput from "@/components/general/diffInput.vue";

//local components
import DaysOfWeekSelect from "./daysOfWeek.select.vue";

export default {
  props: ["value", "isEdit"],
  model: {
    prop: "value",
    event: "change",
  },
  components: {
    diffInput,
    DaysOfWeekSelect,
  },
  data() {
    return {
      columns: [
        {
          label: "Çalışma Günü",
          key: "day",
        },
        {
          label: "Başlangıç Saati",
          key: "startHour",
          dontDisplay: true,
          center: true,
        },
        {
          label: "Bitiş Saati",
          key: "endHour",
          dontDisplay: true,
          center: true,
        },
      ],
      startHour: null,
      endHour: null,
      List: [],
      days: [],
      // price: 0,
    };
  },
  methods: {
    save() {
      try {
        if (!this.startHour) {
          this.swalBox(
            "warning",
            "UYARI",
            "Başlangıç saati seçiniz!",
            false,
            "Tamam"
          );
          return;
        }

        if (!this.endHour) {
          this.swalBox(
            "warning",
            "UYARI",
            "Bitiş saati seçiniz!",
            false,
            "Tamam"
          );
          return;
        }

        if (this.startHour === this.endHour) {
          this.swalBox(
            "warning",
            "UYARI",
            "Başlangıç ve bitiş saatleri aynı olamaz!",
            false,
            "Tamam"
          );
          return;
        }

        if (this.days.length < 1) {
          this.swalBox(
            "warning",
            "UYARI",
            "En az 1 gün seçmelisiniz!",
            false,
            "Tamam"
          );
          return;
        }
        for (const day of this.days) {
          const params = {
            dayId: day.dayId,
            day: day.name,
            startHour: this.startHour,
            endHour: this.endHour,
            status: 2,
          };
          const newArr = [...this.List, params];
          this.List = newArr;
        }
        this.startHour = null;
        this.endHour = null;
        this.days = [];
      } catch (error) {
        this.swalBox(
          "warning",
          "UYARI",
          "Çalışma günü eklenemedi!",
          false,
          "Tamam"
        );
      }
    },
    removeItem(val, item) {
      this.swalBox(
        "warning",
        this.$t("general.warningTitle"),
        "İş gününü silmek istediğinize emin misiniz?",
        true,
        this.$t("general.yes"),
        this.$t("general.no")
      ).then((acc) => {
        if (acc.isConfirmed) {
          try {
            if (this.isEdit && item.status === 1) {
              this.List[val].status = 3;
            } else {
              this.List.splice(val, 1);
            }
          } catch (error) {
            this.swalBox(
              "warning",
              "UYARI",
              "İş günü silinemedi!",
              false,
              "Tamam"
            );
          }
        }
      });
    },
    reverseDelete(val) {
      this.swalBox(
        "warning",
        this.$t("general.warningTitle"),
        "İş gününü geri almak istediğinize emin misiniz?",
        true,
        this.$t("general.yes"),
        this.$t("general.no")
      ).then((acc) => {
        if (acc.isConfirmed) {
          this.List[val].status = 1;
        }
      });
    },
  },
  created() {
    this.List = [];
  },
  computed: {
    sortedList() {
      return this.List.sort((a, b) => a.dayId - b.dayId);
    },
  },
  watch: {
    value(val) {
      this.List = val;
    },
    List(val) {
      this.$emit("change", val);
    },
  },
};
</script>
